<template>
    <div class="common-count-down">
        <span v-if="!styletype"><span>{{ day }}</span>&nbsp;day&nbsp;</span><span>{{ hours }}</span><span v-if="!styletype">:</span><span v-else>:</span><span>{{ minute }}</span><span v-if="!styletype">:</span><span v-else>:</span><span>{{ second }}</span>
    </div>
</template>

<script>

export default {
  name: 'CountDown',
  data () {
    return {
      flag: false,
      day: '',
      hours: '',
      minute: '',
      second: '',
      time: ''
    }
  },
  props: {
    timesurplus: {},
    timelimithour: {},
    timetype: {},
    styletype:{},
  },
  mounted () {
    this.time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(this.time)
      } else {
        this.timeDown()
      }
    }, 1000)
  },
  methods: {
    timeDown () {
      let leftTime = 0
      if (this.timetype == 1) {
        leftTime = parseInt(this.timesurplus / 1000)
      } else if (this.timetype == 2) {
        leftTime = parseInt((this.timesurplus * 1000 + this.timelimithour * 60 * 60 * 1000 - new Date().getTime()) / 1000)
      }
      if(!this.styletype){
          this.day = parseInt(leftTime / (24 * 60 * 60))
      }

      this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
      this.minute = this.formate(parseInt((leftTime / 60) % 60))
      this.second = this.formate(parseInt(leftTime % 60))
      if (leftTime <= 0) {
        this.flag = true
        this.$emit('time-end')
      }
    },
    /*
             * 格式化时间
             */
    formate (time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.common-count-down{
    font-size:.6rem;color:#999;
}
</style>
